import * as React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon, XCircleIcon } from "lucide-react";

import { cn } from "@/src/lib/utils";
import { Calendar, CalendarProps } from "@/src/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/src/components/ui/popover";
import { Button } from "@/src/components/ui/button";

export function DatePicker({
  value,
  onChange,
  className,
  fromDate,
  disabledDays,
  readOnly,
}: {
  readOnly?: boolean;
  value?: Date;
  onChange: (day: any) => void;
  className?: string;
  fromDate?: CalendarProps["fromDate"];
  disabledDays?: CalendarProps["disabled"];
}) {
  return (
    <Popover>
      <PopoverTrigger disabled={readOnly} asChild>
        <Button
          variant={"outline"}
          className={cn(
            "w-[280px] justify-start text-left font-normal bg-white hover:bg-white",
            !value && "text-muted-foreground",
            className,
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {value ? format(value, "PPP") : <span className="text-slate-400 font-normal">Select date...</span>}
          {value && (
            <span className="ml-auto" onClick={() => onChange(undefined)}>
              <XCircleIcon size={16} />
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          fromDate={fromDate}
          disabled={disabledDays}
          mode="single"
          selected={value}
          onSelect={onChange}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
